module.exports = __webpack_public_path__ + "assets/img/role-b79041f4.png";